<template>
  <p>{{ text }}</p>
</template>

<script>
export default {
  props: {
    time: {
      type: Number,
      default: 0,
    },
    format: {
      type: String,
      default: 'h:m:s',
    },
  },
  data() {
    return {
      timer: '',
      now: new Date().getTime(),
      text: '',
    }
  },
  mounted() {
    this.countTime()
    this.timer = setInterval(() => {
      this.countTime()
    }, 1000)
  },
  destroyed() {
    clearInterval(this.timer)
  },
  methods: {
    countTime() {
      // 获取当前时间
      const now = new Date().getTime()
      // 设置截止时间 时间搓
      const end = this.time
      // 时间差
      const leftTime = end - now
      // 定义变量 d,h,m,s保存倒计时的时间
      let time = {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
      }
      if (leftTime >= 0) {
        time.d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
        time.h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
        time.m = Math.floor((leftTime / 1000 / 60) % 60)
        time.s = Math.floor((leftTime / 1000) % 60)
      } else {
        clearInterval(this.timer)
        this.$emit('finish')
      }
      this.text = this.format.replace(/([hms])/g, (result, key) => {
        const value = time[key]
        // Note: getDay() returns 0 on Sunday
        return value.toString().padStart(2, '0')
      })
    },
  },
}
</script>

<style scoped>
</style>
